import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
//cookie
import { getCookie } from 'src/webapp/config/cookie';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useRefreshAccessTokenHook from 'src/webapp/hooks/useRefreshAccessTokenHook';
//comp
import Spinner from 'src/webapp/views/component/loading/Spinner';
import {
    Login
    , Signup, SignupId, SignupPasswd
    , Auth, AuthEmail, AuthTel, Verify
    , InfoStep01, InfoStep02, InfoStep03, InfoStep04, InfoStep05, InfoStep06, InfoStep03Test
    , Success, Fail
    , FindId, FindIdSuccess, FindPasswd, FindPasswdReset, FindVerify
    , Mypage
} from 'src/webapp/views/user';
import { Dashboard, NotifyList, Schedule, Items, Sales, Members, CalcList, Market, MarketReg, MarketDetail, MarketUpdate } from 'src/webapp/views';
import NotFound from './NotFound';

export default function Router(props) {
    const navigator = useNavigate();//navigator
    const { isState } = usePartnerStore();
    //location
    const location = useLocation();
    const locate = location.pathname;
    //hook
    const { partnerTokenCheckAPI, fcmTokenCheckHandler, updateFcmTokenAPI } = useRefreshAccessTokenHook();//로그인세션유비여부, FCM토큰업데이트호출 및 업데이트
    
    /* =============== 리프레시토큰-쿠키값 =============== */
    const refreshToken = getCookie("NIDRP");
    /* =============== 리프레시토큰-쿠키값 =============== */
    /* =============== 로그인세션유지여부 =============== */
    useEffect(() => {(async () => {
        const noneAccessTransition = [ "/" ];//url과 100%일치
        const noneAccessTransition2 = [ "signup", "login", "find" ];//url에 특정path포함
        if(noneAccessTransition.indexOf(locate) >= 0 || noneAccessTransition2.indexOf(locate.split('/')[1]) >= 0) { return; }
        
        const result = await partnerTokenCheckAPI();
        if(!result) { 
            navigator("/", {replace:true}); 
        }
    })()}, [locate]);
    /* =============== 로그인세션유지여부 =============== */
    /* =============== FCM토큰저장(APP) =============== */
    useEffect(() => {
        window.onFcmInfoSuccess = (token) => { updateFcmTokenAPI(token); };
        document.onFcmInfoSuccess = (token) => { updateFcmTokenAPI(token); };
    }, []);
    useEffect(() => {
        if(locate !== "/" || !isState) { return; }

        fcmTokenCheckHandler();
    }, [locate, isState]);
    /* =============== FCM토큰저장(APP) =============== */
    const routes = [
        {path: "/", element: refreshToken === undefined || refreshToken === null ? <Suspense fallback={<Spinner />}><Login /></Suspense> : <Dashboard /> },
        , {path: "/signup"
            , children: [{ index: true, element: <Signup /> }
                , { path: "id", element: <SignupId /> }
                , { path: "password", element: <SignupPasswd /> }
                , { path: "auth", element: <Auth /> }
                , { path: "auth/email", element: <AuthEmail /> }
                , { path: "auth/tel", element: <AuthTel /> }
                , { path: "auth/verify", element: <Verify /> }
                , { path: "info/1", element: <InfoStep01 /> }
                , { path: "info/2", element: <InfoStep02 /> }
                , { path: "info/3", element: <InfoStep03Test /> }
                , { path: "info/4", element: <InfoStep04 /> }
                , { path: "info/5", element: <InfoStep05 /> }
                , { path: "info/6", element: <InfoStep06 /> }
                , { path: "success", element: <Success /> }
                , { path: "fail", element: <Fail /> }
                , { path: "test", element: <InfoStep03Test /> }
        ]}
        , {path: "/find"
            , children: [{ index: true, path: "id", element: <FindId /> }
                , { path: "id/success", element: <FindIdSuccess /> }
                , { path: "passwd", element: <FindPasswd /> }
                , { path: "passwd/reset", element: <FindPasswdReset /> }
                , { path: "verify", element: <FindVerify /> }
        ]}
        , { path: "/dashboard", element: <Dashboard /> }
        , { path: "/mypage", element: <Mypage /> }
        , { path: "/schedule", element: <Schedule /> }
        , { path: "/item", element: <Items /> }
        , { path: "/sales", element: <Sales /> }
        , { path: "/members", element: <Members /> }
        , { path: "/notify", element: <NotifyList /> }
        , { path: "/calc", element: <CalcList /> }
        , { path: "/market", element: <Market /> }
        , {path: "/market"
            , children: [{ index: true, element: <Market /> }
                , { path: "reg", element: <MarketReg /> }
                , { path: "update/:seq", element: <MarketUpdate /> }
                , { path: "detail/:seq", element: <MarketDetail /> }
        ]}
        , { path: "/notfound", element: <NotFound /> }
        // , { path: "/success", element: Success }
    ];
    let router = useRoutes(routes);

    return (router);
}